import { schema } from 'normalizr';
import workoutSchema from '../workout/schema';
import * as Utils from '../../../lib/designerUtils';

const daySchema = new schema.Entity(
    'days',
    {
        items: new schema.Array(workoutSchema)
    },
    {
        idAttribute: entity => Utils.getDayKey(entity),
        processStrategy: entity => {
            const item = { ...entity };
            item.items = [];
            return item;
        }
    }
);

export default daySchema;



// WEBPACK FOOTER //
// ./src/state/reducer/day/schema.js